import { InjectionToken } from '@angular/core';
import { IUser } from './models';
import { MediaInfo } from './stacking-plan-container/stacking-plan.model';

/**
 * Set of configurations used by stacking plan library.
 *
 * Required Configurations:
 * - {@link baseUrl}
 */
export interface StackingPlanConfiguration {
  /**
   * Base URL value used to make API requests. It must be a regular HTTP/HTTPS
   * URL with no trailing slash.
   *
   * @example
   * 'https://localhost:4200'
   */
  baseUrl: string;
  media: MediaInfo;
}
export interface OverlayUtilsConfiguration {
  isExceeded(min: number, minUOM: string, max: number, maxUOM: string): boolean;
}

export interface UserInfoResolver {
  resolve(): IUser;
}

export interface PvSideBySideTemplates {
  EnvId: string;
  TemplafyId: string;
  TemplateHubId: string;
}

/**
 * Token used to inject a object that follows the
 * {@link StackingPlanConfiguration} interface. It must be used wherever we
 * need to inject the host/base URL.
 *
 * @example
 * class MyService {
 *   constructor (@Inject(STACKING_PLAN_CONFIGS_TOKEN)spConfigurations: StackingPlanConfiguration) {
 *     console.log(spConfigurations.baseUrl);
 *   }
 * }
 */
export const STACKING_PLAN_CONFIGS_TOKEN = new InjectionToken<StackingPlanConfiguration>('STACKING_PLAN_CONFIGS_TOKEN');
export const OVERLAY_UTILS_TOKEN = new InjectionToken<OverlayUtilsConfiguration>('OVERLAY_UTILS_TOKEN');
export const INFO_USER_RESOLVER_TOKEN = new InjectionToken<UserInfoResolver>('INFO_USER_RESOLVER_TOKEN');
export const PV_SIDE_BY_SIDE_TEMPLATES_TOKEN = new InjectionToken<PvSideBySideTemplates>(
  'PV_SIDE_BY_SIDE_TEMPLATES_TOKEN'
);
